import { revalidateTag, unstable_cache } from 'next/cache';
import { ImportedData, ImportedDataType } from './ImportedData.types';
import { ImportedDataService } from './ImportedData.service';
import { sparkleUtils } from 'src/shared/sparkle-utils';

export class ImportedDataProvider {
  constructor(
    private readonly _importedDataService: ImportedDataService,
    private readonly _cacheDuration: number
  ) {}

  public async getDataFor(slug: string, dataType: ImportedDataType): Promise<ImportedData> {
    if (sparkleUtils.isEmptyOrWhiteSpace(slug)) return {} as ImportedData;

    const data = await unstable_cache(
      () => this._importedDataService.getData(slug, dataType),
      [slug, dataType.toString()],
      {
        revalidate: this._cacheDuration,
      }
    )();

    if (data == ({} as ImportedData)) {
      revalidateTag(slug);
    }

    return data ?? ({} as ImportedData);
  }
}
